module.exports = __webpack_public_path__ + "2e6b12b5876ccb92765ca42b235471f0.pdf";